(function ($, window) {
    'use strict';

    $(document).ready(function () {
        window.AdminKit.sidebar.init();
        window.AdminKit.dropdown.init();
        window.AdminKit.theme.init();

        if (window.AdminKit.select2) {
            window.AdminKit.select2.init();
        }

        if (window.AdminKit.datatable) {
            window.AdminKit.datatable.init();
        }

        $('.password-toggle').on('click', function () {
            var $button = $(this);
            var $input = $button.closest('.password-field').find('input');
            var showPassword = $input.attr('type') === 'password';

            $input.attr('type', showPassword ? 'text' : 'password');
            $button.find('i').toggleClass('fa-eye', !showPassword).toggleClass('fa-eye-slash', showPassword);
        });

        $('.login-card').on('submit', function () {
            var $button = $(this).find('.login-submit');

            $button.addClass('is-loading').find('span').text('Signing in');
            $button.find('i').removeClass('fa-arrow-right').addClass('fa-spinner');
        });
    });
})(jQuery, window);
